
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from '../../components/Code.js'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Adapting based on props`}</h2>
    <p>{`You can pass a function ("interpolations") to a styled component's template literal to adapt it based on its props.`}</p>
    <p>{`This button component has a primary state that changes its color. When setting the `}<Code mdxType="Code">{`primary`}</Code>{` prop to true, we are swapping out its background and text color.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`const Button = styled.button\`
  /* Adapt the colors based on primary prop */
  background: \${props => props.primary ? "palevioletred" : "white"};
  color: \${props => props.primary ? "white" : "palevioletred"};

  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid palevioletred;
  border-radius: 3px;
\`;

render(
  <div>
    <Button>Normal</Button>
    <Button primary>Primary</Button>
  </div>
);
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;